import React, {
	useEffect,
	useState,
	useRef,
	useMemo,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import { GreenroomState } from '../../../stores/types/types';
import { MODAL_AVATAR_ACTIONS, MODAL_TEMPLATES } from '../../../stores/reducers/modal';
import * as SessionActions from '../../../stores/actions/session';
import * as ModalActions from '../../../stores/actions/modal';
import Icon, { COLORS, ICONS } from '../../general-components/icon';
import { showAlert } from '../../general-components/alert-service';
import { getChannelLogoFromMeeting } from '../../../utils/utils';

export default function HomeSettings() {
	const dispatch = useDispatch();
	const selectedChannel = useSelector((state: GreenroomState) => state.HomeReducer.selectedChannel);
	const token = useSelector((state: GreenroomState) => state.SessionReducer.token);

	const titleRef = useRef<HTMLInputElement | null>(null);
	const [channelTitle, setChannelTitle] = useState<string>(selectedChannel?.name ?? '');

	useEffect(() => {
		if (selectedChannel) setChannelTitle(selectedChannel.name);
	}, [selectedChannel]);

	const blur = () => {
		if (!token || !selectedChannel || !titleRef.current) {
			// do nothing
		} else if (!channelTitle) {
			titleRef.current.focus();
			showAlert({
				message: 'Name required',
				description: 'You need at least one character for your channel name.',
				duration: 2000,
				type: 'neutral',
			});
		} else {
			dispatch(SessionActions.updateChannel(
				token,
				{ ...selectedChannel, name: channelTitle },
			));
		}
	};

	const openChannelIconModal = () => {
		dispatch(ModalActions.setModalState({
			modalOpen: true,
			modalTemplate: MODAL_TEMPLATES.AVATAR_PHOTO,
			modalData: {
				isOnboarding: false,
				modalAvatarAction: MODAL_AVATAR_ACTIONS.CHANNEL_ICON,
			},
		}));
	};

	const channelLogo = useMemo(() => getChannelLogoFromMeeting(selectedChannel), [selectedChannel]);

	return (
		<div className="settings-view margin-large width-full">
			<h1 className="text-light-gray font-weight-bold height-32">Settings</h1>
			<div className="flex">
				<div className="channel-icon-container flex-column background-medium border-radius-medium margin-right-medium">
					<span className="font-size-16 font-weight-bold line-height-20">Channel icon</span>
					<div
						className={classNames(
							'channel-icon-upload flex-center text-light-gray font-weight-heavy border-radius-small cursor-pointer',
							channelLogo && 'has-icon',
						)}
						style={{
							backgroundImage: channelLogo
								? `url('${channelLogo}')`
								: 'none',
						}}
						onClick={openChannelIconModal}
					>
						<Icon name={ICONS.ADD} color={COLORS.LIGHT_GRAY} size={16} className={'margin-right-small'} />
						Image
					</div>
				</div>
				<div className="channel-title-container flex-column background-medium border-radius-medium">
					<span className="font-size-16 font-weight-bold line-height-20">Channel title</span>
					<span className="text-gray font-size-14 font-weight-heavy line-height-20">Change the name of your channel</span>
					<input
						type="text"
						onChange={(e: React.ChangeEvent<HTMLInputElement>) => setChannelTitle(e.target.value)}
						onBlur={blur}
						value={channelTitle ?? ''}
						ref={titleRef}
					/>
				</div>
			</div>
		</div>
	);
}
